import React from 'react'
import { withSiteData, Head } from 'react-static'

import Hero from '../components/Hero'
import OurWork from '../components/Our-Work'
import Offices from '../components/Offices'
import Industrial from '../components/Industrial'
import Residential from '../components/Residential'
import Team from '../components/Team'
import Contact from '../components/Contact'

const heroOptions = {
  title: "Glenbeigh Developments Ltd projects",
  image: "hero-projects.jpg"
}

export default withSiteData(({ siteTitle }) => (
  <React.Fragment>
    <Head>
      <title>{ siteTitle } | Projects</title>
    </Head>
    <Hero {...heroOptions} />
    <OurWork />
    <Offices />
    <Industrial />
    <Residential />
    <Team />
    <Contact />
  </React.Fragment>
))



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/containers/Projects.js